/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { Box, useTheme } from "@mui/system";
import { Button, Typography } from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import { useNavigate } from "react-router";

import UseWindowDimensions from "../../../../utils/windowSize";
import CustomHelmet from "./../../CustomHelmet/index";
import logoType from "../../../../media/svg/logo-type.svg";
import logoIcon from "../../../../media/svg/logo-icon.svg";

const LoginMain = () => {
  const theme = useTheme();
  const { height } = UseWindowDimensions();
  const navigate = useNavigate();

  useEffect(() => {
    // alert(width);
  }, []);

  // function gtagFunc(url) {
  //   var callback = function () {
  //     // eslint-disable-next-line valid-typeof
  //     if (typeof url != undefined) {
  //       window.location = url;
  //     }
  //   };
  //   // eslint-disable-next-line no-restricted-globals, no-undef
  //   gtag(event, conversion, {
  //     send_to: "AW-11196502862/edzgCN7mgaYYEM6m9Nop",
  //     event_callback: callback,
  //   });
  //   return false;
  // }

  return (
    <>
      <CustomHelmet title={`Login | Azad`} />

      <Box
        sx={{
          display: "flex",
          height: height + "px",
          alignItems: "end",
          backgroundColor: "white.main",
          mb: "15px",
        }}
      >
        <Box>
          <Box
            sx={{
              px: "16px",
              mb: "48px",
              textAlign: "center",
              position: "fixed",
              top: 0,
              width: "100%",
            }}
          >
            <Box sx={{ px: "16px", mt: "60px", textAlign: "center" }}>
              <Box
                sx={{
                  padding: "16px 0 10px 0",
                  display: "flex",
                  flexDirection: "column",
                  mb: "24px",
                  alignItems: "center",
                }}
              >
                <img
                  src={logoIcon}
                  alt='Azad Logo Icon'
                  width='100px'
                  height='100px'
                />
                <img
                  style={{ marginTop: "15px" }}
                  src={logoType}
                  alt='Azad Logo Name'
                  width='130px'
                  height='38px'
                />
              </Box>
            </Box>

            {/* <Typography
              sx={{
                fontSize: "40px",
                fontWeight: 500,
                fontFamily: "Tahrir",
                lineHeight: "40px",
              }}
            >
              Change the world by your opinions
            </Typography> */}
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              border: "2px solid",
              borderColor: "black.main",
              padding: "24px 16px 16px 16px",
              borderRadius: "16px 16px 0 0",
              position: "fixed",
              bottom: 0,
            }}
          >
            <Box sx={{ mb: "20px" }}>
              <Typography
                sx={{ display: "inline-block", fontSize: "18px", mb: "8px" }}
              >
                To your
                <Typography
                  component={"span"}
                  sx={{
                    fontWeight: 700,
                    display: "inline-block",
                    px: "3px",
                    fontSize: "20px",
                  }}
                >
                  safety
                </Typography>
                and
                <Typography
                  component={"span"}
                  sx={{
                    fontWeight: 700,
                    display: "inline-block",
                    pl: "3px",
                    fontSize: "20px",
                  }}
                >
                  right to anonymity
                </Typography>
                , logging in to Azad is only possible with a Google account. We
                do not keep any information about you, even your email.
              </Typography>

              <Typography sx={{ fontSize: "16px", color: "textField.main" }}>
                You can read more about it
                <Typography
                  component={"span"}
                  onClick={() => navigate("/about")}
                  sx={{
                    fontWeight: "700",
                    color: "secondary.main",
                    display: "inline-block",
                    pl: "3px",
                    cursor: "pointer",
                  }}
                >
                  here
                </Typography>
                .
              </Typography>
            </Box>

            <Button
              // onClick={gtagFunc}
              href={`${process.env.REACT_APP_API}/auth/social/google/redirect/`}
              variant='contained'
              sx={{
                fontSize: "20px",
                fontWeight: 600,
                width: "100%",
                height: "48px",
                padding: "0",
                border: "2px solid",
                borderColor: "black.main",
                boxShadow: `0px 4px 0px ${theme.palette.black.main}`,
                pt: "4px",
                borderRadius: "8px",
                mb: "25px",
                "&.MuiButtonBase-root:hover": {
                  boxShadow: "none",
                  backgroundColor: "primary.main",
                },
                "&.MuiButtonBase-root:active": {
                  backgroundColor: "black.main",
                  color: "white.main",
                  boxShadow: "none",
                },
              }}
            >
              <GoogleIcon sx={{ mb: "5px", mr: "5px" }} /> Continue With Google
            </Button>
            <Box
              sx={{
                fontSize: "16px",
                color: "textField.main",
              }}
            >
              By Logging in, You agree to our
              <Box
                sx={{ display: "inline-flex", cursor: "pointer" }}
                onClick={() => navigate("/terms")}
              >
                <Typography
                  component={"span"}
                  sx={{
                    fontWeight: "700",
                    color: "secondary.main",
                    display: "inline-block",
                    px: "3px",
                  }}
                >
                  Terms and
                </Typography>
                <Typography
                  component={"span"}
                  sx={{
                    fontWeight: "700",
                    color: "secondary.main",
                    display: "inline-block",
                    pl: "3px",
                  }}
                >
                  Conditions.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default LoginMain;
